"use strict";

var _regeneratorRuntime = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _classCallCheck = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var lengthFromProperties = require("../utils").lengthFromProperties;

var idlUtils = require("./generated/utils");

var privates = Symbol("NodeList internal slots");

var NodeList = /*#__PURE__*/function () {
  function NodeList(secret, config) {
    _classCallCheck(this, NodeList);

    if (secret !== privates) {
      throw new TypeError("Invalid constructor");
    }

    if (config.nodes) {
      this[privates] = {
        isLive: false,
        length: config.nodes.length
      };

      for (var i = 0; i < config.nodes.length; ++i) {
        this[i] = config.nodes[i];
      }
    } else {
      this[privates] = {
        isLive: true,
        element: config.element,
        query: config.query,
        snapshot: undefined,
        length: 0,
        version: -1
      };
      updateNodeList(this);
    }
  }

  _createClass(NodeList, [{
    key: "item",
    value: function item(index) {
      updateNodeList(this);
      return this[index] || null;
    } // TODO reimplement this in webidl2js so these become more per-spec

  }, {
    key: "keys",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function keys() {
      var length, i;
      return _regeneratorRuntime.wrap(function keys$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              updateNodeList(this);
              length = this[privates].length;
              i = 0;

            case 3:
              if (!(i < length)) {
                _context.next = 9;
                break;
              }

              _context.next = 6;
              return i;

            case 6:
              ++i;
              _context.next = 3;
              break;

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, keys, this);
    })
  }, {
    key: "entries",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function entries() {
      var length, i;
      return _regeneratorRuntime.wrap(function entries$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              updateNodeList(this);
              length = this[privates].length;
              i = 0;

            case 3:
              if (!(i < length)) {
                _context2.next = 9;
                break;
              }

              _context2.next = 6;
              return [i, this[i]];

            case 6:
              ++i;
              _context2.next = 3;
              break;

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, entries, this);
    })
  }, {
    key: "forEach",
    value: function forEach(callback) {
      var thisArg = arguments[1]; // TODO Node v6: use default arguments

      var values = Array.from(this);
      var i = 0;

      while (i < values.length) {
        callback.call(thisArg, values[i], i, this);
        values = Array.from(this);
        ++i;
      }
    }
  }, {
    key: "length",
    get: function get() {
      updateNodeList(this);
      return this[privates].length;
    }
  }]);

  return NodeList;
}();

NodeList.prototype[Symbol.iterator] = NodeList.prototype.values = Array.prototype[Symbol.iterator];

function updateNodeList(nodeList) {
  if (nodeList[privates].isLive) {
    if (nodeList[privates].version < nodeList[privates].element._version) {
      nodeList[privates].snapshot = nodeList[privates].query();
      resetNodeListTo(nodeList, nodeList[privates].snapshot);
      nodeList[privates].version = nodeList[privates].element._version;
    }
  } else {
    nodeList[privates].length = lengthFromProperties(nodeList);
  }
}

function resetNodeListTo(nodeList, nodes) {
  var startingLength = lengthFromProperties(nodeList);

  for (var i = 0; i < startingLength; ++i) {
    delete nodeList[i];
  }

  for (var _i = 0; _i < nodes.length; ++_i) {
    var wrapper = idlUtils.wrapperForImpl(nodes[_i]);
    nodeList[_i] = wrapper ? wrapper : nodes[_i];
  }

  nodeList[privates].length = nodes.length;
}

module.exports = function (core) {
  core.NodeList = NodeList;
};

module.exports.createLive = function (element, query) {
  return new NodeList(privates, {
    element: element,
    query: query
  });
};

module.exports.createStatic = function (nodes) {
  return new NodeList(privates, {
    nodes: nodes
  });
};

module.exports.update = updateNodeList;